"use strict";

global.Dialog = require('./dialog').default;
global.FormConfirmDelete = require('./form_confirm_delete').default;
global.FormConfirmRestore = require('./form_confirm_restore').default;
global.FormFileSizeValidation = require('./form_file_size_validation').default;
global.CourseSearch = require('./course_search').default;
global.Search = require('./search').default;

// init form deletion confirmation event
new FormConfirmDelete();

// Initilize form restore confirmation event
new FormConfirmRestore();

// init form file size validation
new FormFileSizeValidation();

// nav
require('./nav');
